import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import lefticon from "../images/Leftnew.svg";

export default function VerificationPage() {
  const [verificationCode, setVerificationCode] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const inputs = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useParams();
  const [email, setEmail] = useState("");

  useEffect(() => {
    // Get email from URL params
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    if (emailParam) {
      setEmail(emailParam);
    }

    // If there's a token, verify directly
    if (token) {
      verifyEmailWithToken();
    }
  }, [location, token]);

  const verifyEmailWithToken = async () => {
    try {
      await axios.get(
        `https://app.metabolytics.ai/simulator-backend/healthcare/verify/${token}`
      );
      alert("Email Verified! Please log in.");
      navigate("/login");
    } catch (error) {
      setError("Invalid or expired token.");
    }
  };

  const handleInput = (index, e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return; // Only allow numbers

    const newCode = [...verificationCode];
    newCode[index] = value;
    setVerificationCode(newCode);

    // Move to next input if value is entered
    if (value && index < inputs.current.length - 1) {
      inputs.current[index + 1].focus();
    }

    setError(""); // Clear any previous errors
  };

  const handleBackspace = (index, e) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  const handleVerify = async () => {
    const code = verificationCode.join("");
    if (code.length !== 4) {
      setError("Please enter the complete verification code");
      return;
    }

    setLoading(true);
    try {
      await axios.post(
        "https://app.metabolytics.ai/simulator-backend/healthcare/verify-email",
        {
          email,
          code,
        }
      );
      alert("Email verified successfully!");
      navigate("/login");
    } catch (error) {
      setError(error.response?.data?.message || "Invalid verification code");
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    if (!email) {
      setError("Email address not found");
      return;
    }

    try {
      await axios.post(
        "https://app.metabolytics.ai/simulator-backend/healthcare/resend-verification",
        { email }
      );
      alert("New verification code has been sent to your email!");
    } catch (error) {
      setError("Failed to resend verification code. Please try again.");
    }
  };

  return (
    <div className="Login-container-bg">
      <div className="Login-container-main">
        <div className="setup-container-main">
          <div
            className="setup-icon-container"
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
          >
            <img src={lefticon} alt="Left Icon" className="setup-icon" />
          </div>

          <h2 className="setup-title">Verification Code</h2>
          <p className="setup-description">
            Enter code that we have sent to your email
            <br />
            <span className="email-display">{email}</span>
          </p>

          <div className="verification-input-container">
            {verificationCode.map((digit, i) => (
              <input
                key={i}
                type="text"
                maxLength="1"
                className="code-input"
                value={digit}
                ref={(el) => (inputs.current[i] = el)}
                onChange={(e) => handleInput(i, e)}
                onKeyDown={(e) => handleBackspace(i, e)}
              />
            ))}
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="login-button-container">
            <button
              className="verify-button"
              onClick={handleVerify}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify"}
            </button>
          </div>

          <p
            className="resend-code"
            onClick={handleResendCode}
            style={{ cursor: "pointer" }}
          >
            Resend Code
          </p>
        </div>
      </div>
    </div>
  );
}
